@app.directive 'matrixItemList', (matrixItemService, $location) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @isRecipe = matrixItemService.isRecipe
    @urlMatches = ->
      $location.path() == @content.url
    this
  controllerAs: 'matrixItemList'
  templateUrl: "/assets/templates/components/matrix/matrixItem/matrixItemList/matrixItemList.html"
  bindToController: {
    content: '='
    descriptionCharLimit: '='
    showLikes: '='
    itemNumber: '='
    loadImageOnEnterViewport: '='
    track: '&'
  }
